import React from "react";
import style from "./style.module.css";
import * as Animate from "react-reveal";
import AvatarImage from "../../../../assets/images/png/avatar.webp";
import { Link } from "react-router-dom";
import Logo from "../../../../assets/images/svg/logo/utivacolored.svg";
import ButtonLink from "../../../../components/elements/ButtonLink";

const TopSection = () => {
  return (
    <section className={`relative w-full`}>
      <header id="header" className={`relative bg-transparent pt-8 pb-8`}>
        <div className={`container mx-auto relative px-4`}>
          <div className="flex justify-between items-center">
            <div className="w-3/12">
              <Link to="/">
                <img src={Logo} alt="" />
                <span className="sr-only">Utiva</span>
              </Link>
            </div>
            <div className="">
              <a
                href={"https://forms.gle/2VvPEn3LotyB9ZTr6"}
                target={"_blank"}
                rel="noopener noreferrer"
                className="py-4 px-6 rounded-xl bg-secondary font-semibold text-white text-sm lg:text-sm-15 hover:-translate-y-1 transition-all ease-in-out"
              >
                Apply Now
              </a>
            </div>
          </div>
        </div>
      </header>
      <div
        className={`container px-4 mx-auto pt-28 pb-20 md:pb-28 lg:pb-36 flex flex-wrap justify-between items-center ${style.bg}`}
      >
        <div className="w-full xl:w-10/12 mx-auto text-center relative">
          <Animate.Fade bottom>
            <h1
              className={`w-full lg:w-10/12 mx-auto font-medium text-4xl md:text-5xl lg:text-6xl xl:text-8xl font-mono ${style.gradentText}`}
            >
              Binance Charity Tech Scholarship
            </h1>
            <p className=" mt-8 lg:mt-10 text-base lg:text-xl lg:leading-9 text-center w-full lg:w-10/12 xl:w-7/12 mx-auto">
              Educating 50,000 Young Africans in Technology Skills and Web3
            </p>

            <div className="w-full md:w-8/12 lg:w-5/12 mx-auto text-center mt-12">
              <Animate.Fade bottom>
                <ButtonLink
                  isExternalLink={true}
                  title={"Download Brochure"}
                  url="https://drive.google.com/file/d/1KzR_rM1fN-MqeGvJJpSfqM611Ih8JLyz/view?usp=share_link"
                  target="_blank"
                  rel="noopener noreferrer"
                />
              </Animate.Fade>
            </div>

            <div className="mt-10 lg:mt-12 flex justify-center items-center mx-auto">
              <div className="flex flex-row items-center border border-secondary rounded-full py-2 px-4">
                <div className="w-14 lg:w-20">
                  <img src={AvatarImage} alt="" />
                </div>
                <p className="text-xs md:text-sm lg:text-sm-15 pl-3 pr-3 -mt-1">
                  Over 50,000 lives to be impacted
                </p>
              </div>
            </div>
          </Animate.Fade>
        </div>
      </div>
    </section>
  );
};

export default TopSection;
